
<template>
    <div class='purshase-product-list'>
         
            <purshase-product-info v-for="(product,index) in purshaseProducts" 
                                    :purshaseProduct="product" 
                                    :index="index+1" 
                                    :key="'pp'+product.id" >
            </purshase-product-info>
    </div>
</template>

<script>

import _ from 'lodash';
import validateForms from '@/mixins/validateForms';

export default {
    mixins: [validateForms],
    data(){
        return {
            open:false
        }
    },
    props:{
    },

    computed:{
       order:function(){
            return this.$store.getters['OrderStore/currentOrder']
       },
       purshaseProducts:function(){
             return this.$store.getters['OrderStore/purshaseProductsForCurrentOrder']
       }
    },

    methods:{
       removeCartItem:function(){
            this.$store.dispatch('removeProductFromCart', { cartItemId:this.item.cartItemId } ) 
       },
       
       formsOk:async function(){
           //for each for check if need fill on purchase
           //LETODO !IMPORTANT - fazer verificar quando precisa ou não
        //    return true;
           return await this.validateForms();
       }
    }
}
</script>

<style lang="stylus">

    .circle-number{
        opacity:0.4
        display:inline-block;
        width 25px
        height: 25px;
        font-size:16px;
        line-height:25px;
        font-weight bold
        border-radius: 50%;
        background:gray;
        color:white;
        text-align:center    
    }

    

</style>
